(() => {
  const select = (selector, scope = document) => scope.querySelector(selector);
  const selectAll = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  const announce = (message) => {
    const toast = select('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  };

  selectAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = select(`#${button.getAttribute('aria-controls')}`);
      if (!menu) return;
      const open = menu.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('se-nav-open', open);
    });
  });

  selectAll('[data-quote-builder]').forEach((builder) => {
    const panes = selectAll('[data-quote-pane]', builder);
    const steps = selectAll('[data-quote-step]', builder);
    const error = select('[data-quote-error]', builder);
    const form = select('form', builder);
    let current = 0;

    const radioValue = (name) => select(`input[name="${name}"]:checked`, builder)?.value || '';
    const radioLabel = (name) => {
      const input = select(`input[name="${name}"]:checked`, builder);
      if (!input) return '';
      const label = select(`label[for="${input.id}"]`, builder);
      return select('strong', label)?.textContent.trim() || input.value;
    };

    const recommendation = () => {
      const application = radioValue('se_application');
      const surface = radioValue('se_surface');
      const environment = radioValue('se_environment');
      if (application === 'delivery') return { name: 'Tamper-Evident Security Strip', size: '1.35 × 8.75 in', material: 'Tamper-evident film / permanent adhesive', roll: '500 labels per roll', reason: 'A long-format seal designed to bridge delivery bags and packaging with visible opening evidence.' };
      if (surface === 'thermal' || application === 'inventory') return { name: 'Direct Thermal Removable Label', size: '1 × 1.1875 in', material: 'Direct thermal polypropylene / removable adhesive', roll: '2,000 labels per roll', reason: 'A practical fit for prep, rotation, inventory, and Zebra-compatible workflows where clean removal matters.' };
      if (environment === 'cold_wet' || application === 'containers') return { name: 'Round Waterproof BOPP Label', size: '1.5 in round', material: 'White BOPP / moisture-resistant adhesive', roll: '1,000 labels per roll', reason: 'A durable brand or closure label for refrigerated cups and containers exposed to condensation.' };
      return { name: 'Custom Label Program', size: 'Configured to application', material: 'Paper or film matched after sample review', roll: 'Roll count matched to operations', reason: 'A flexible specification path for nonstandard sizes, branded systems, or multi-location programs.' };
    };

    const renderRecommendation = () => {
      const result = recommendation();
      const fields = {
        '[data-rec-name]': result.name,
        '[data-rec-reason]': result.reason,
        '[data-rec-size]': result.size,
        '[data-rec-material]': result.material,
        '[data-rec-roll]': result.roll,
        '[data-rec-volume]': radioLabel('se_volume')
      };
      Object.entries(fields).forEach(([key, value]) => { const node = select(key, builder); if (node) node.textContent = value; });
      const brief = select('[data-quote-brief]', builder);
      if (brief) brief.value = [
        `Application: ${radioLabel('se_application')}`,
        `Surface: ${radioLabel('se_surface')}`,
        `Environment: ${radioLabel('se_environment')}`,
        `Monthly volume: ${radioLabel('se_volume')}`,
        `Starting recommendation: ${result.name} — ${result.size}`
      ].join('\n');
    };

    const validationMessage = () => {
      if (current === 0 && !radioValue('se_application')) return 'Choose the closest application to continue.';
      if (current === 1 && (!radioValue('se_surface') || !radioValue('se_environment'))) return 'Choose both a surface and an operating environment.';
      if (current === 2 && !radioValue('se_volume')) return 'Choose an estimated monthly quantity.';
      return '';
    };

    const render = () => {
      panes.forEach((pane, index) => pane.classList.toggle('is-active', index === current));
      steps.forEach((step, index) => step.classList.toggle('is-active', index === current));
      if (error) error.textContent = '';
      if (current === 3) renderRecommendation();
      select('.se-quote-main', builder)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    selectAll('[data-quote-next]', builder).forEach((button) => button.addEventListener('click', () => {
      const message = validationMessage();
      if (message) { if (error) error.textContent = message; return; }
      current = Math.min(current + 1, panes.length - 1);
      render();
    }));

    selectAll('[data-quote-back]', builder).forEach((button) => button.addEventListener('click', () => {
      current = Math.max(current - 1, 0);
      render();
    }));

    form?.addEventListener('submit', () => {
      renderRecommendation();
      announce('Preparing your quote request');
    });

    render();
  });

  selectAll('[data-variant-select]').forEach((selectElement) => {
    selectElement.addEventListener('change', () => {
      const selected = selectElement.options[selectElement.selectedIndex];
      const price = select('[data-product-price]', selectElement.closest('[data-product-info]'));
      if (price && selected.dataset.price) price.textContent = selected.dataset.price;
    });
  });
})();
